{
  "greeting": "您好！我可以如何協助您選擇葡萄酒？",
  "thinking": "✨ 思考中...",
  "thinkingStep": "✨ 思考中... {step}",
  "askAboutWine": "例如：1990年代波爾多紅酒約$1500 | 勃根地村莊白酒低於$600",
  "askAboutWineFirst": "我想尋找葡萄酒...（產地 + 葡萄酒顏色 + 年份 + 價格）",
  "waitingForResponse": "等待回應中...",
  "dailyLimitReached": "您已達到今日的諮詢限額。請於香港時間 00:00 後再次訪問。",
  "chatHistory": "您的聊天記錄",
  "noChatHistory": "尚無聊天記錄",
  "startConversation": "開始對話以查看記錄",
  "backToChat": "返回聊天",
  "newChat": "新聊天",
  "history": "記錄",
  "search": "搜尋",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "您的專屬葡萄酒顧問",
  "chat": "聊天",
  "chatNumber": "聊天 {number}",
  "wineRecommended": "推薦了 {count} 款葡萄酒",
  "winesRecommended": "推薦了 {count} 款葡萄酒",
  "justNow": "剛剛",
  "minuteAgo": "{count} 分鐘前",
  "minutesAgo": "{count} 分鐘前",
  "hourAgo": "{count} 小時前",
  "hoursAgo": "{count} 小時前",
  "dayAgo": "{count} 天前",
  "daysAgo": "{count} 天前",
  "noMessagesYet": "尚無訊息",
  "perBottle": "每瓶",
  "priceNA": "價格不詳",
  "buyNow": "立即購買",
  "moreInformation": "更多資訊",
  "share": {
    "button": "分享",
    "title": "分享對話",
    "description": "使用下面的連結與朋友分享這段對話：",
    "generating": "正在生成分享連結...",
    "error": "生成分享連結失敗",
    "copy": "複製",
    "copied": "已複製！",
    "note": "注意：此連結將在30天後過期。當有人打開此連結時，他們將看到這段對話的副本。"
  },
  "checkOutWine": "看看這款葡萄酒：{name} {vintage}",
  "linkCopied": "連結已複製到剪貼簿！",
  "contactWhatsApp": "透過 WhatsApp 聯絡我們以獲得更多選擇",
  "errorLoadingWine": "抱歉，無法載入葡萄酒詳細資訊。",
  "errorOccurred": "獲取回應時發生錯誤。",
  "you": "您",
  "welcome": {
    "intro": "我是Zyra，您的智能葡萄酒顧問，我可以為您建議：",
    "features": {
      "globalMarket": "跨市場（英國、法國、香港）貨源實時報價和數量",
      "personalized": "按您的預算建議最合適的選擇",
      "instantCheckout": "結帳付款、物流配送和倉存選項"
    },
    "question": "Zyra 誠意為您推薦...",
    "trendingPrompts": "範例查詢（目前貨幣設定是港幣）",
    "promptExamples": {
      "title": "如何詢問：",
      "good": "✓ 良好範例：",
      "bad": "✗ 避免沒有預算的查詢："
    },
    "prompts": {
      "bordeaux": "800美元左右的波爾多紅酒",
      "champagne": "2000美元以下的種植者香檳",
      "firstGrowth": "2010-2019年一級酒莊最佳報價"
    }
  },
  "feedback": {
    "helpful": "這很有幫助",
    "notHelpful": "這沒有幫助",
    "thankYou": "感謝您的反饋！",
    "whatDidYouLike": "您喜歡什麼？",
    "whatCouldBeImproved": "有什麼可以改進的？",
    "category": "類別",
    "selectCategory": "選擇類別",
    "categories": {
      "accuracy": "準確性",
      "helpfulness": "實用性",
      "responseSpeed": "回應速度",
      "clarity": "清晰度",
      "other": "其他"
    },
    "comments": "意見",
    "placeholder": "告訴我們更多關於您的體驗...",
    "cancel": "取消",
    "submit": "提交反饋",
    "submitting": "提交中..."
  },
  "auth": {
    "limitReached": "已達每日限制",
    "signUpToday": "註冊以獲得更多訊息",
    "limitMessage": "您已達到每日訊息限制。註冊免費帳戶以繼續聊天。",
    "benefitsMessage": "創建免費帳戶以繼續聊天並在各設備上保存您的聊天記錄。",
    "remainingMessages": "您今天還有 {count} 條訊息",
    "signUp": "註冊",
    "login": "登入",
    "loggedInAs": "已登入為 {email}",
    "logout": "登出"
  }
}
